import React from 'react'
import { PrimeIcons } from 'primereact/api';

function Previewww({ primaryColor, secColor, selectedFile }) {
    return (
        <div className="card card-round p-0 mb-0" style={{ width: '100%' }}>
            
                <div className="grid" style={{ background: primaryColor, borderRadius: '10px', height: '60px' }}>
                    <div className="col-2 flex align-items-center" style={{ height: '100%' }}>
                        <img src={selectedFile} alt="Logo" className="logo" style={{ height: '100%', borderRadius: '10px' }} />
                    </div>
                    <div className="col-8 justify-content-around pt-4" style={{ height: '100%', display: 'flex' }}>
                        <h6 className="m-0" style={{ color: secColor }}>
                            Home
                        </h6>
                        <h6 className="m-0" style={{ color: secColor }}>
                            Products
                        </h6>
                        <h6 className="m-0" style={{ color: secColor }}>
                            About Us
                        </h6>
                        <h6 className="m-0" style={{ color: secColor }}>
                            Contact Us
                        </h6>
                    </div>
                    <div className="col-2 justify-content-around" style={{ display: 'flex', alignItems: 'center' }}>
                        <i className={`pi ${PrimeIcons.SHOPPING_CART}`} style={{ fontSize: '24px', color: secColor }}></i>
                    </div>
                </div>
        </div>
    );
}

export default Previewww